// extracted by mini-css-extract-plugin
export default {"cellText":"AX8T653Zy8FEE9N94Omu"};